export default "__VITE_ASSET__bab1c937__"